<template>
  <multiselect-item
    id="idBanco"
    track-by="id_banco"
    :value="value"
    @input="($event) => $emit('input', $event)"
    :custom-label="(option) => `${option.id_banco} - ${option.nombre}`"
    placeholder="Seleccione un banco"
    :options="bancosOptions"
    :loading="isLoading"
  >
  </multiselect-item>
</template>
<script>
import { get } from "lodash-es";
import AdaptarVueModel from "./AdaptarVueModel";
import axios from "axios";

export default {
  name: "SelectorBanco",
  props: ["value"],
  mixins: [AdaptarVueModel],
  mounted() {
    this.getData().then((resp) => {
      if (!resp.ok) {
        this.$msgBoxOk(resp.message);
      }
    });
  },
  data: () => ({
    isLoading: true,
    bancosOptions: [],
  }),
  methods: {
    async getData() {
      this.isLoading = true;
      try {
        const resp = await axios.post("/execute", {
          method: "CLI.GetBancos",
          parameters: [],
        });
        if (resp.data.ok) {
          this.bancosOptions = get(resp, "data.result[0]", []);
          this.adaptarVueModel(this.bancosOptions, "id_banco");
        } else {
          this.$msgBoxOk(resp.data.message);
        }
        this.isLoading = false;
      } catch (e) {
        this.$msgBoxOk(e.toString());
      }
    },
    computed: {
      banco: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit("input", val);
        },
      },
    },
  },
};
</script>
<style scoped></style>
